import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightBibleSearch'
})
export class HighlightBibleSearchPipe implements PipeTransform {
  
  transform(text: string, search: string, cssClass: string = 'highlighted-search-text'): string {
    if (!search || !text) return text;

    const normalizedSearch = this.removeAccents(search.trim()); // Elimina espacios al inicio/final
    const normalizedText = this.removeAccents(text);
    
    // Escapa caracteres especiales y permite espacios en la búsqueda
    const escapedSearch = this.escapeRegExp(normalizedSearch);
    const pattern = new RegExp(`(${escapedSearch})`, 'gi');

    let result = '';
    let lastIndex = 0;

    // Usamos el texto normalizado para buscar, pero aplicamos el resaltado al texto original
    normalizedText.replace(pattern, (match, p1, offset) => {
      result += text.substring(lastIndex, offset);
      result += `<span class="${cssClass}">${text.substring(offset, offset + match.length)}</span>`;
      lastIndex = offset + match.length;
      return match;
    });

    result += text.substring(lastIndex);

    return result;
  }

// Función para eliminar tildes
  private removeAccents(str: string): string {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  // Función para escapar caracteres especiales en regex
  private escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

}
